import React, {useState, useEffect} from 'react';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import Button from '@material-ui/core/Button';
import EditRecipe from './EditRecipe';
import EditIcon from '@material-ui/icons/Edit';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

const Recipe = (props) => {
    
    const [recipe, setRecipe] = useState(undefined);
    const [edit, setEdit] = useState(false);

    useEffect(() => {
        const getSingleRecipe = async () => {
            const singleRecipe = await fetch(`https://recipe-app-backend-ionut.herokuapp.com/${props.match.params.id}`);
            const response = await singleRecipe.json();
            setRecipe(response);
        }
        getSingleRecipe();

    },[recipe, props.match.params.id]);

    const history = useHistory();

    const deleteRecipe = () => {
        alert('You really want to delete it?');
       axios.delete(`https://recipe-app-backend-ionut.herokuapp.com/recipes/${props.match.params.id}`)
       .then(response => console.log(response))
       .catch(err => console.log(err))

       history.push("/");
    }

    const renderRecipe = () => {
        return ( 
        <div className="top-section">
            <Button
                className="delete-button"
                onClick={deleteRecipe}
                startIcon={<DeleteForeverIcon />}>
                Delete Recipe
            </Button>

            <Button
                className="edit-button"
                onClick={() => setEdit(!edit)}
                startIcon={<EditIcon />}>
                Edit Recipe
            </Button>           

            <h2>{recipe.name}</h2>

            <div className="ingredients">
                <h3>Recipe ingredients:</h3>
                <ul>
                    <li key={recipe._id}>{recipe.ingredients}</li>
                </ul>
            </div>

            <div className="description-section">
                <h3 className="description">How to make it:</h3>
                <pre>
                    <p>{recipe.description}</p>
                </pre>
            </div>
        </div>
        )
    }

    return (
        <div className="recipe">

            {recipe && renderRecipe()}
        
            { edit ? (
                <div className="bottom-section">
                    <EditRecipe 
                        edit={edit}
                        setEdit={setEdit}
                        recipeId={props.match.params.id} 
                        name={recipe.name} 
                        ingredients={recipe.ingredients} 
                        description={recipe.description} 
                    />
                </div>
            ) : ( <> </>)
            } 
            
        </div>

        
    )
}


export default Recipe;
